import React from 'react';
import Checkbox from './types/Checkbox.jsx';
import Color from './types/Color.jsx';
import Radio from './types/Radio.jsx';
import Range from './types/Range.jsx';
import Tiled from './types/Tiled.jsx';

function FilterType({filter, filterOptionChange, dropdown, mobileSubmitButton}) {
    if (filter.checkbox) {
        return (
            <Checkbox
                filterOptionChange={filterOptionChange}
                identifier={filter.identifier}
                filterOptions={filter.filterOptions}
                trackingId={filter.trackingId}
                hideNumberOfItems={!filter.numberOfItemsVisible}
            />
        );
    } else if (filter.color) {
        return (
            <Color
                filterOptionChange={filterOptionChange}
                identifier={filter.identifier}
                filterOptions={filter.filterOptions}
                trackingId={filter.trackingId}
            />
        );
    } else if (filter.radio) {
        return (
            <Radio
                filterOptionChange={filterOptionChange}
                identifier={filter.identifier}
                filterOptions={filter.filterOptions}
                trackingId={filter.trackingId}
                hideNumberOfItems={!filter.numberOfItemsVisible}
            />
        );
    } else if (filter.rangeSlider) {
        return (
            <Range
                filterOptionChange={filterOptionChange}
                identifier={filter.identifier}
                filterOptions={filter.filterOptions}
                trackingId={filter.trackingId}
                unit={filter.unit}
                dropdown={dropdown}
                mobileSubmitButton={mobileSubmitButton}
                range={filter.range}
            />
        );
    } else if (filter.tiled) {
        return (
            <Tiled
                filterOptionChange={filterOptionChange}
                identifier={filter.identifier}
                filterOptions={filter.filterOptions}
                trackingId={filter.trackingId}
            />
        );
    }
    return <></>;
}

export default React.memo(FilterType);
